import React, { Component } from "react";
import styled from "styled-components";

// HOC //
import withChat from "hoc/withChat";

// Utils //
import history from "utils/history";

// Components //
import CodeEditor from "components/CodeEditor";
import Text from "components/Text";
import StepFooter from 'components/StepFooter';
import StepHeader from 'components/StepHeader';

const Root = styled.div``;

const Header = styled(StepHeader)`
  margin-bottom: 40px;
`;

class Step1 extends Component {
  state = {
    value: `const client = new StreamChat("qk4nn7rpcn75");

await client.setUser({
  id: "jon-snow",
  name: "Jon Snow",
  image: "https://bit.ly/2u9Vc0r",
}, token); // token generated server side

return client;
`
  };

  run = async () => {
    const { setClient, setError, StreamChat, token, setLoading, setStepComplete } = this.props; // eslint-disable-line no-unused-vars
    const { value } = this.state;

    try {
      await setLoading(true);
      const client = await eval(`(async () => {${value}})();`); // eslint-disable-line no-eval
      await setClient(client);
      await setStepComplete(0);
      await setLoading(false);
    } catch (err) {
      await setLoading(false);
      setError(err.message);
    }
  };

  handleCodeChange = value => {
    this.setState({
      value
    });
  };

  handlePrevClick = () => history.push('/')

  handleNextClick = async () => {
    try {
      await this.run();
      history.push(`/step-2`)
    }
    catch (e) {
      console.log(e)
    }
  };

  render() {
    const { loading } = this.props;
    const { value } = this.state;
    return (
      <Root>
        <Header
          step={1}
          title="Setup a connection"
        >
          <Text size={18}>
            Ok, so we’re going to build a Messaging style chat. Let's get started by connecting to Stream:
          </Text>
        </Header>
        <CodeEditor
          onChange={this.handleCodeChange}
          value={value}
        />
        <Text size={18} style={{marginTop: 24}}>
          In the code above we connect to Stream and set the current user to{" "}
          <strong>Jon Snow</strong>.
        </Text>
        <StepFooter
          nextLabel="Initialize"
          loading={loading}
          onNextClick={this.handleNextClick}
          onPrevClick={this.handlePrevClick}
        />
      </Root>
    );
  }
}

export default withChat(Step1);
